import formsBackendClient, { type ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';

import buildPath from '../utilities/buildPath';

type ThisApi = ApiDefinition['/questionnaire-templates/{creatorId}']['GET'];
type Input = ThisApi['params'];

const getQuestionnaireTemplates = async ({ creatorId }: Input): Promise<ThisApi['response']> => {
  const path = buildPath<ThisApi>('/questionnaire-templates/{creatorId}', { creatorId });
  const data = await formsBackendClient.get(path);
  return data.data;
};

export default getQuestionnaireTemplates;
